import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { createCustomer} from '../../redux/actions/customer/CustomerAction';

const addCustomer = ({customers,createCustomer,history}) => {
    const [firstName,setFirstName]=useState('');
    const [lastName,setLastName]=useState('');
    const [email,setEmail]=useState('');
    const[address,setAddress]=useState('');
    const[password,setPassword]=useState('');

    useEffect(()=>{
        console.log(customers);
        if(customers.length>0){
            const id=customers[0].customerId;
            const customerList=JSON.parse(localStorage.getItem('customerlist'))||[];
            customerList.push({email,password,id});
            localStorage.setItem('customerlist',JSON.stringify(customerList));
            history.push('/customer/login');
        }
        
    },[customers]);
    
    const postData=(e)=>{
        e.preventDefault();

        if (!firstName || !lastName || !email || !address || !password) {
            return alert('Please fill in all fields!!');
        }

        console.log(customers);
        createCustomer({
            firstName,
            lastName,
            email,
            address,
                
        });
        console.log(customers);
        
        
    };

    return (
        <div className="container-fluid">
            <h4 className="text-center text-dark py-2">Create Customer</h4>
            <div className="row">
                <div className="col-md-5 p-5 mx-auto shadow d-flex justify-content-center">

                    <form className='create-form'>
                        <div className="form-group my-3">
                            <label>Enter First Name:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="First name"
                                value={firstName}
                                onChange={(e)=>setFirstName(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group my-3">
                            <label>Enter Last Name:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Last name"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group my-3">
                            <label>Enter Email here:</label>
                            <input
                                className="form-control"
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group my-3">
                            <label>Enter Address Here:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Address"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group my-3">
                            <label>Enter Password Here:</label>
                            <input
                                className="form-control"
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                         
                        <div className="form-group my-3">
                            <button onClick={postData} type="submit" className="btn btn-primary">
                Submit
                            </button>
                            <button  type="reset" className="btn btn-warning mx-2">
                Clear
                            </button>
                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    customers:state.customers,
});
const mapDispatchToProps={createCustomer};

export default connect(mapStateToProps, mapDispatchToProps)(addCustomer);
